import InfoIcon from '@material-ui/icons/Info'
import * as React from 'react'
import { darkGray, information } from 'shared/theme/colors'
import { centeredContent } from 'shared/theme/mixins'
import { paragraph2 } from 'shared/theme/typography'
import styled from 'styled-components'

import TooltipBase, { TOOLTIP_DIRECTIONS } from '../../components/Tooltip/Tooltip'

const Tooltip = styled(TooltipBase)<{ $width?: string; $addGutter?: boolean; $openerWidth?: string }>`
  color: white;
  cursor: default;
  z-index: 9999999;
  display: inline-block;

  ${(p) => p.$addGutter && `top: 4px; margin-left: 4px;`}
  ${(p) => p.zIndex && `z-index: ${p.zIndex};`}
  ${(p) => p.$openerWidth && `width: ${p.$openerWidth};`}

  .react-tooltip-lite {
    color: white;
    background: white;
    ${(p) => p.$width && `width: ${p.$width};`}
  }

  .react-tooltip-lite-arrow {
    border-color: transparent;
  }
`

const Container = styled.div<{ $width?: string }>`
  ${centeredContent};
  align-items: flex-start;
  left: 400px;
  width: 424px;
  padding: 24px;
  background: ${information};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  ${paragraph2};
  margin: 0;
  color: ${darkGray};
  ${(p) => p.$width && `width: ${p.$width};`}
`

export const InfoTooltipParagraph = styled.p`
  ${paragraph2};
  margin: 0;
  color: ${darkGray};

  & + & {
    margin-top: 12px;
  }
`

interface InfoTooltipOpenerProps {
  className?: string
  tooltip: React.ReactNode
  children: React.ReactNode
  width?: string
  openerWidth?: string
  zIndex?: number
  addGutter?: boolean
  direction?: TOOLTIP_DIRECTIONS
}

interface InfoTooltipProps extends Omit<InfoTooltipOpenerProps, 'tooltip'> {}

export function InfoTooltipOpener({
  className,
  children,
  tooltip,
  width,
  openerWidth,
  zIndex,
  addGutter,
  direction = TOOLTIP_DIRECTIONS.RIGHT,
}: InfoTooltipOpenerProps) {
  if (!tooltip) return <>{children}</>

  return (
    <Tooltip
      className={className}
      direction={direction}
      zIndex={zIndex ?? 9999999}
      $addGutter={addGutter}
      $width={width}
      $openerWidth={openerWidth}
      content={
        <Container $width={width} className="tooltip-content-container">
          <div style={{ width: '100%' }}>{tooltip}</div>
        </Container>
      }
    >
      {children}
    </Tooltip>
  )
}

const StyledInfoIcon = styled(InfoIcon)`
  font-size: 16px;
`

export function InfoTooltip({ className, children, ...props }: InfoTooltipProps) {
  return (
    <InfoTooltipOpener className={className} tooltip={children} {...props} addGutter>
      <StyledInfoIcon fontSize="small" color="primary" />
    </InfoTooltipOpener>
  )
}
